import React, { useState, useEffect } from 'react';
import Header from '../../../common/components/Header/Header';
import Sidebar from '../../../common/components/Sidebar/Sidebar';
import Helmet from 'react-helmet';
import { siteTitle } from '../../../../data/SiteConfig';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight } from '@fortawesome/pro-light-svg-icons';
import ReportsTopBarFilter from './ReportsTopBarFilter';
import {
  getTeamPerformanceReport,
  getReportTotal
} from '../../../common/constants/api';
import * as _ from 'lodash';
import TeamPerformanceTable from '../TeamPerformance/TeamPerformanceTable/TeamPerformanceTabel';
import PopUp from '../../../common/components/PopUp/PopUp';
import moment from 'moment';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';
import { getUserType } from '../../../common/utils/cookie-utils';
import { navigate } from 'gatsby';
import {
  setFiltersInfo,
  getFiltersInfo
} from '../../../common/utils/FiltersInfo';

const TeamPerformance = () => {
  const [changeMonth, setChangeMonth] = useState(
    getFiltersInfo()?.targetMonth || undefined
  );
  const [city, setCity] = useState({
    value: getFiltersInfo()?.cityFilterTP?.value || '',
    label: getFiltersInfo()?.cityFilterTP?.label || 'Select City'
  });
  const [tableData, setTableData] = useState([]);
  const [tableInfo, setTableInfo] = useState({ size: 1000 });
  const [tableLoading, setTableLoading] = useState(true);
  const [firstLoading, setFirstLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(1000);
  const [rmId, setRmId] = useState(getFiltersInfo()?.rm || '');
  const [filteredProduct, setFilteredProduct] = useState(
    getFiltersInfo()?.productId || ''
  );
  const [sortColumnName, setSortColumnName] = useState('name');
  const [sortDirName, setSortDirName] = useState('ASC');
  const [source, setSource] = useState(getFiltersInfo()?.sourceFilter || '');
  const [isTotalFetching, setIsTotalFetching] = useState(true);
  const [totalData, setTotalData] = useState({});
  const [tableCombinedData, setTableCombinedData] = useState([]);
  const [isApisCallProgress, setIsApisCallProgress] = useState(false);

  const [isInitialTotalDataLoading, setIsInitialTotalDataLoading] = useState(
    true
  );

  const getTeamTotalValue = () => {
    setIsApisCallProgress(true);
    setIsTotalFetching(true);
    getReportTotal({
      type: 'team',
      targetMonth: `${changeMonth?.year ||
        moment().format('YYYY')}-${changeMonth?.month ||
        moment().format('MM')}-28`,
      rmUserId: rmId,
      productId: filteredProduct,
      cityId: city?.value,
      leadSourceId: source
    })
      .then(res => {
        setIsTotalFetching(false);
        setTotalData(res || {});
        setIsInitialTotalDataLoading(false);
      })
      .catch(error => {
        setIsTotalFetching(false);
        setIsInitialTotalDataLoading(false);
      });
  };

  const getPerformanceReport = () => {
    setTableLoading(true);
    setIsApisCallProgress(true);
    getTeamPerformanceReport(
      `${changeMonth?.year ? changeMonth.year : moment().format('YYYY')}-${
        changeMonth?.month ? changeMonth.month : moment().format('MM')
      }-28`,
      page,
      pageSize,
      city?.value || '',
      rmId,
      filteredProduct,
      sortColumnName,
      sortDirName,
      source
    )
      .then(res => {
        if (res.error) throw new Error(res);
        setTableLoading(false);
        setTableData(res?._embedded?.teams || []);
        setTableInfo(res.page);
        setFirstLoading(false);
      })
      .catch(error => {
        setTableLoading(false);
      });
  };

  useEffect(() => {
    getPerformanceReport();
    getTeamTotalValue();
  }, []);

  useEffect(() => {
    if (isInitialTotalDataLoading) return;
    getTeamTotalValue();
  }, [changeMonth, rmId, filteredProduct, city?.value, source]);

  useEffect(() => {
    setTableCombinedData([
      ...(tableData || []),
      {
        ...(totalData || {}),
        isTotal: true
      }
    ]);
    if (!isTotalFetching && !tableLoading) setIsApisCallProgress(false);
  }, [tableData, totalData]);

  useEffect(() => {
    if (!firstLoading) getPerformanceReport();
  }, [page]);

  useEffect(() => {
    if (!firstLoading) getPerformanceReport();
  }, [pageSize]);

  useEffect(() => {
    if (!firstLoading) getPerformanceReport();
  }, [changeMonth]);

  useEffect(() => {
    if (!firstLoading) getPerformanceReport();
  }, [sortDirName]);

  useEffect(() => {
    if (!firstLoading) getPerformanceReport();
  }, [sortColumnName, source]);

  useEffect(() => {
    if (getUserType() != 1) {
      navigate('/app/dashboard');
    }
  }, []);

  useEffect(() => {
    if (!firstLoading) {
      getPerformanceReport();
      setNewValueInLocalStorage('productId', filteredProduct);
    }
  }, [filteredProduct]);

  useEffect(() => {
    if (!firstLoading) getPerformanceReport();
  }, [city?.value]);

  useEffect(() => {
    getPerformanceReport();
    setNewValueInLocalStorage('rm', rmId);
  }, [rmId]);

  const setNewValueInLocalStorage = (key, value) => {
    let localFilters = getFiltersInfo();
    if (typeof localFilters == 'object') {
      localFilters[key] = value;
      setFiltersInfo(localFilters);
    } else {
      setFiltersInfo({
        key: value
      });
    }
  };

  return (
    <React.Fragment>
      <Helmet title={`Dashboard RM | ${siteTitle}`} />
      <div className="bg-grey-950 relative h-full overflow-hidden font-roboto text-sm font-normal m-0 p-0">
        <div className=" min-h-screen flex pt-17 md:pt-0 ">
          <Sidebar />

          <div className="widhtMd max-screen flex-1  w-full ">
            <div className="flex">
              <div className="flex items-center  flex-col xl:flex-row w-full">
                <div className="w-full text-black-400 text-md ml-4 font-bold mt-4 relative">
                  <span className="mr-1 cursor-pointer">Reports</span>
                  <FontAwesomeIcon
                    icon={faAngleDoubleRight}
                    className="mr-1 mt-1"
                  />
                  <span className="text-green-800">Team Performance</span>
                </div>
              </div>
              <Header />
            </div>
            <div className="w-full">
              <ReportsTopBarFilter
                heading="Filter to see Individual Report"
                component="TP"
                cityName={city}
                setCityName={setCity}
                changeMonth={changeMonth}
                setChangeMonth={setChangeMonth}
                validRange={{
                  min: {
                    year: 1990,
                    month: 1,
                    date: 28
                  },
                  max: {
                    year: parseInt(moment().format('YYYY')),
                    month: moment().month() + 1,
                    date: 28
                  }
                }}
              />
              <TeamPerformanceTable
                tableData={!isApisCallProgress && tableCombinedData}
                tableInfo={tableInfo}
                tableLoading={isApisCallProgress}
                setPage={setPage}
                setPageSize={setPageSize}
                rmId={rmId}
                setRmId={setRmId}
                setFilteredProduct={setFilteredProduct}
                filteredProduct={filteredProduct}
                setSortDirName={setSortDirName}
                setSortColumnName={setSortColumnName}
                firstLoading={firstLoading}
                changeMonth={changeMonth}
                source={source}
                setSource={setSource}
                pageSize={pageSize}
              />
            </div>
            <div className="flex flex-row flex-wrap justify-between ml-6"></div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withErrorHandler(TeamPerformance);
